import { type QueryKey, useInfiniteQuery } from "@tanstack/react-query";
import { type AxiosRequestConfig } from "axios";

import { useApi } from "../../SDKProvider";
import { unwrapAPIResult } from "../../utils/api";
import { type INotificationList } from "../types";
import { notificationListQuery } from "./notificationListQuery";

export const getNextNotificationPage = (pages: INotificationList[], perPage: number) => {
    const totalItems = pages[pages.length - 1]?.["hydra:totalItems"] ?? 0;

    return pages.length * perPage < totalItems ? pages.length + 1 : undefined;
};

export const useNotificationInfiniteListQuery = (
    { perPage }: { perPage: number },
    { queryKey, enabled = true }: { queryKey: QueryKey; enabled?: boolean },
) => {
    const api = useApi();

    return useInfiniteQuery<INotificationList>({
        queryKey,
        enabled,
        queryFn: ({ pageParam = 1 }) =>
            unwrapAPIResult(
                api.request<INotificationList>(
                    notificationListQuery({ pagination: { page: pageParam, perPage } }) as AxiosRequestConfig,
                ),
            ),
        getNextPageParam: (_lastPage, pages) => getNextNotificationPage(pages, perPage),
    });
};
